// extracted by mini-css-extract-plugin
module.exports = {"fake-cursor":"fake-cursor_fake-cursor__fsPT4","blink":"fake-cursor_blink__aoBwD"};